module.exports = __webpack_public_path__ + "994e993808c55a14fe2816ca0869a817.jpg";